import { render, staticRenderFns } from "./checkPageVip.vue?vue&type=template&id=045f09c2&scoped=true&"
import script from "./checkPageVip.vue?vue&type=script&lang=js&"
export * from "./checkPageVip.vue?vue&type=script&lang=js&"
import style0 from "./checkPageVip.vue?vue&type=style&index=0&id=045f09c2&scoped=true&lang=css&"
import style1 from "./checkPageVip.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f09c2",
  null
  
)

export default component.exports